import s3 from '../../../utils/s3ContractingFilesUpload';

export function submitContractingComment(opts) {
  return dispatch => {
    const { contractId, comment, historyFeedId } = opts;
    const files = opts.files || [];
    return dispatch({
      type: 'SUBMIT_CONTRACTING_COMMENT',
      payload: {
        contractId,
        historyFeedId,
        files,
        message: comment,
      },
    });
  };
}

export const contractingCommentInput = (payload) => ({ type: 'HANDLE_CONTRACTING_COMMENT_INPUT', payload });
export const contractingAddFile = (payload) => ({ type: 'HANDLE_CONTRACTING_COMMENT_FILE_INPUT', payload });
export const contractingCancelComment = (payload) => ({ type: 'CANCEL_CONTRACTING_COMMENT', payload });
export const setContractingCommentBoxFocus = (payload) => ({ type: 'SET_CONTRACTING_COMMENT_FOCUS', payload });



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-activities-products/comment-actions.js